import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FacebookIcon } from '../../icons/Facebook';

import { SocialButton } from './SocialButton';

interface IProps {
	onClick: VoidFunction;
}
export const FacebookButton: FC<IProps> = (props) => {
	const { t } = useTranslation('socialLogin');
	const { onClick } = props;

	const handleClick = () => {
		onClick();
	};

	return (
		<SocialButton
			name="facebook"
			text={t('button.facebook')}
			onClick={handleClick}
			icon={<FacebookIcon />}
		/>
	);
};
